// import { toast } from "sonner";
// import { Button, Icon } from "~/components/ui";
// import AddUserNode from "./node";
// export interface AddUserProps {
//   actionMode: boolean;
//   name: string;
// }
// interface Props {
//   userLists: AddUserProps[];
//   setUserLists: React.Dispatch<React.SetStateAction<AddUserProps[]>>;
// }
// const AddUserTag = ({ userLists, setUserLists }: Props) => {
//   const saveUser = (name: string, index: number) => {
//     if (!name.trim()) {
//       return toast.warning("Please enter a name");
//     }
//     setUserLists((prev) => {
//       const updatedList = [...prev];
//       updatedList[index].name = name;
//       updatedList[index].actionMode = false;
//       return updatedList;
//     });
//   };
//   const onCancelAction = (index: number) => {
//     setUserLists((prev) => {
//       const updatedList = [...prev];
//       if (!updatedList[index]) {
//         return prev; // Return previous state if the index is invalid
//       }
//       if (updatedList[index].name.trim() === "") {
//         // If name is empty, remove the item from the list
//         updatedList.splice(index, 1);
//       } else {
//         // If name has value, set actionMode to false
//         updatedList[index].actionMode = false;
//       }
//       return updatedList;
//     });
//   };
//   const setActionMode = (index: number) => {
//     setUserLists((prev) => {
//       const updatedList = [...prev];
//       updatedList[index].actionMode = true;
//       return updatedList;
//     });
//   };
//   const onDeleteAction = (index: number) => {
//     setUserLists((prev) => {
//       const updatedList = [...prev];
//       updatedList.splice(index, 1);
//       return updatedList;
//     });
//   };
//   return (
//     <div>
//       <ul className="flex w-full flex-wrap items-center gap-2">
//         {userLists?.map((item, index) => (
//           <li key={index} onClick={() => setActionMode(index)}>
//             <AddUserNode
//               actionMode={item.actionMode}
//               name={item.name}
//               saveUser={(name: string) => saveUser(name, index)}
//               cancelAction={() => {
//                 onCancelAction(index);
//               }}
//               deleteUser={() => {
//                 onDeleteAction(index);
//               }}
//             />
//           </li>
//         ))}
//         <li>
//           <Button
//             onClick={() => {
//               setUserLists((prev) => [...prev, { name: "", actionMode: true }]);
//             }}
//             type="button"
//             variant="default"
//             size="xs"
//             className="flex items-center gap-2 rounded-full px-2.5 py-0.5"
//           >
//             <span>Add New</span>
//             <Icon name="Plus" className="h-4 w-4 text-white" />
//           </Button>
//         </li>
//       </ul>
//     </div>
//   );
// };
// export default AddUserTag;
import { toast } from "sonner";
import { Button, Icon } from "~/components/ui";

import AddUserNode from "./node";

export interface AddUserProps {
  actionMode: boolean;
  name: string;
}

interface Props {
  userLists: AddUserProps[];
  setUserLists: React.Dispatch<React.SetStateAction<AddUserProps[]>>;
  title?: string;
}

const AddUserTag = ({ userLists, setUserLists, title }: Props) => {
  const saveUser = (name: string, index: number) => {
    if (!name.trim()) {
      return toast.warning("Please enter a name");
    }

    if (
      userLists.some(
        (user, i) =>
          user.name.toLowerCase() === name.toLowerCase() && i !== index,
      )
    ) {
      return toast.warning("This user already exists");
    }

    setUserLists((prev) => {
      const updatedList = [...prev];
      updatedList[index].name = name.trim();
      updatedList[index].actionMode = false;
      return updatedList;
    });
  };

  const onCancelAction = (index: number) => {
    setUserLists((prev) => {
      const updatedList = [...prev];
      if (!updatedList[index]) {
        return prev; // Return previous state if the index is invalid
      }

      if (updatedList[index].name.trim() === "") {
        // If name is empty, remove the item from the list
        updatedList.splice(index, 1);
      } else {
        // If name has value, set actionMode to false
        updatedList[index].actionMode = false;
      }

      return updatedList;
    });
  };

  const setActionMode = (index: number) => {
    setUserLists((prev) => {
      const updatedList = [...prev];
      updatedList[index].actionMode = true;
      return updatedList;
    });
  };

  const onDeleteAction = (index: number) => {
    setUserLists((prev) => {
      const updatedList = [...prev];
      updatedList.splice(index, 1);
      return updatedList;
    });
  };

  const addNewUser = () => {
    setUserLists((prev) => {
      const newUser = { name: "", actionMode: true };

      if (
        prev.some(
          (user) => user.name.toLowerCase() === newUser.name.toLowerCase(),
        )
      ) {
        toast.warning("Duplicate entry not allowed");
        return prev;
      }

      return [...prev, newUser];
    });
  };

  return (
    <div>
      <ul className="flex w-full flex-wrap items-center gap-2">
        {userLists?.map((item, index) => (
          <li key={index} onClick={() => setActionMode(index)}>
            <AddUserNode
              actionMode={item.actionMode}
              name={item.name}
              saveUser={(name: string) => saveUser(name, index)}
              cancelAction={() => {
                onCancelAction(index);
              }}
              deleteUser={() => {
                onDeleteAction(index);
              }}
            />
          </li>
        ))}
        <li>
          <Button
            onClick={addNewUser}
            type="button"
            variant="default"
            size="xs"
            className="flex items-center gap-2 rounded-full px-2.5 py-0.5"
          >
            <Icon name="Plus" className="h-4 w-4 text-white" />
            <span>{title}</span>
          </Button>
        </li>
      </ul>
    </div>
  );
};

export default AddUserTag;
